<template>
  <section class="py-32 md:py-88">
    <div class="container">
      <div class="flex justify-center">
        <div class="w-full md:w-10/12 lg:w-2/3">
          <h1 class="text-h-xl md:text-h-3xl font-bold pb-16 md:pb-32">
            Disclaimer
          </h1>
          <div class="c-content">
            <h3>Please read text below</h3>
            <ul>
              <li>
                {{ siteName }} does not evaluate or guarantee the accuracy or success of any answers, advice or
                services given through the Site. The site and the services provided by {{ siteName }} are provided "as
                is" with no warranty.
              </li>
              <li>
                {{ siteName }} expressly disclaims any warranty, regarding the site and all services, including any
                implied warranty of merchant fitness for a particular purpose or for failure of performance.
              </li>
              <li>
                {{ siteName }} does not warrant that the services provided by {{ siteName }} or the site of the
                verification that services will be free from bias, defects, errors, eavesdropping or listening.
              </li>
              <li>
                {{ siteName }} shall not be responsible for the quality of information or the authentication of the
                services or details given by {{ advisors }} on the site. By using this site you accept
                the terms and conditions of this Disclaimer.
              </li>
              <li>
                You agree that any use you make of such answers, advice or services is at your own risk and that
                {{ siteName }} is not responsible for any damages or losses resulting from your reliance on such
                answers or advice.
              </li>
              <li>
                By submitting a question here, you understand and expressly agree that {{ siteName }} is not
                responsible for any reply or information that you do or do not receive, and you expressly agree to hold
                {{ siteName }} harmless from any loss, harm, injury, or damage whatsoever resulting from or arising
                out of your submission of the question or your use of or reliance on any response thereto.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { theme } from '@/theme';

const { siteName, advisors } = theme.general;
</script>

<script lang="ts">
export default {
  name: 'SeStaticDisclaimerPage',
};
</script>
